/** Strips spaces and hyphens from a barcode string for normalization. */
export function normalizeBarcode(value: string): string {
  return value.replace(/[\s-]/g, '');
}

/**
 * Detects if a string looks like a barcode (UPC/EAN).
 * Normalizes spaces/hyphens first, then checks for 8-14 digits.
 */
export function looksLikeBarcode(value: string): boolean {
  return /^\d{8,14}$/.test(normalizeBarcode(value));
}
